
import SmallLoader from '../../../components/small-loader';
import Row from './row';


const List = ({ featureToggles, onDelete, canDelete, canCancel, onCancel, otherClientImageJobsInProgress, otherClientDataJobsInProgress, showJobPriorityPoints, onGetJobs }:any) => {
    
const onEnable = (featureToggleId: string, enabled: boolean) => {
    // Implement enable/disable feature toggle logic here
};

    return (
            <div className="columns">
              <div className="column">
                     <>
            
            <table className="geotek-table">
                <thead>
                    <tr>            
                        <th>Name</th>
                        <th>Enabled</th>                        
                    </tr>
                </thead>
                <tbody>
                {(featureToggles || []).map((featureToggle: any, index: number) => (
                    <Row key={featureToggle.id} 
                                    featureToggle={featureToggle}
                                    onEnable={onEnable}
                                     />
                ))}
                </tbody>
            </table>
        </>       
              </div>
            </div>
    )    
};

export default List;